export const siteInfo = {
  name: '88影视网',
  title: '88影视网 - 高清影视在线观看 | 高清电影电视剧超清影视播放不卡顿',
  description: '88影视网提供高清影视在线观看资源，涵盖高清电影电视剧、超清影视播放等内容，画质清晰不模糊，高清不卡顿影视体验，让您畅享高清视频网站的极致观影。',
  keywords: '88影视网,高清影视在线观看,高清电影电视剧,超清影视播放,高清不卡顿影视,高清视频网站,高清在线观看,免费高清影视',
};

export const navItems = [
  { label: '首页', href: '#hero' },
  { label: '影视快讯', href: '#updates' },
  { label: '专题合集', href: '#index' },
  { label: '平台优势', href: '#features' },
  { label: '观众口碑', href: '#comments' },
  { label: '关于我们', href: '#about' },
  { label: '联系我们', href: '#contact' },
];

export const updates = [
  {
    date: '2026-07-30',
    tag: '定档',
    title: '《流浪地球3》正式定档2027年春节，首支概念预告片今日发布',
    summary: '郭帆导演确认第三部将聚焦太阳氦闪危机，刘德华、吴京等原班人马悉数回归，视效预算再创新高。',
  },
  {
    date: '2026-07-28',
    tag: '续订',
    title: 'HBO官宣《龙之家族》第三季续订，预计2027年夏季开播',
    summary: '第二季大结局收视率创下HBO年度新高，第三季将深入讲述血龙狂舞的核心战役。',
  },
  {
    date: '2026-07-25',
    tag: '热播',
    title: '国产科幻剧《三体：黑暗森林》拍摄进度过半，首批剧照曝光',
    summary: '制作团队远赴冰岛、挪威取景，罗辑选角引发全网热议，预计2027年上线。',
  },
  {
    date: '2026-07-22',
    tag: '榜单',
    title: 'Netflix年度热榜出炉，《鱿鱼游戏》第三季全球观看时长破纪录',
    summary: '累计观看时长突破30亿小时，韩剧全球化再下一城，第四季已确认开发中。',
  },
  {
    date: '2026-07-20',
    tag: '颁奖',
    title: '第98届奥斯卡最佳影片提名名单公布，亚洲电影占据三席',
    summary: '中日韩三国作品同时入围最佳影片，创亚洲电影在奥斯卡的历史最佳成绩。',
  },
  {
    date: '2026-07-18',
    tag: '官宣',
    title: '漫威正式公布《复仇者联盟：秘密战争》全新阵容与概念图',
    summary: '小罗伯特·唐尼以全新角色回归，死侍与金刚狼确认加入漫威电影宇宙主线。',
  },
  {
    date: '2026-07-15',
    tag: '回归',
    title: '《庆余年》第三季剧本已全部完成，张若昀领衔原班人马回归',
    summary: '编剧王倦透露第三季将是整个系列的高潮篇章，预计2027年初开机拍摄。',
  },
];

export const mediaItems = [
  {
    title: '最新上映 · 动作巨制抢先看',
    label: '热播中',
    image: 'https://readdy.ai/api/search-image?query=Epic%20action%20movie%20scene%20with%20explosive%20urban%20battlefield%2C%20cinematic%20lighting%20with%20warm%20golden%20and%20amber%20tones%2C%20dramatic%20composition%2C%20professional%20movie%20poster%20aesthetic%2C%20rich%20contrast%2C%20filmic%20color%20grading%2C%20dark%20moody%20atmosphere%20with%20bright%20highlights&width=640&height=360&seq=media-action-movie-01&orientation=landscape',
    duration: '2:35',
  },
  {
    title: '热播剧集 · 悬疑推理口碑之作',
    label: '9.2分',
    image: 'https://readdy.ai/api/search-image?query=Suspenseful%20crime%20drama%20scene%20in%20rainy%20city%20alley%2C%20noir%20cinematography%20with%20deep%20shadows%20and%20warm%20street%20lights%2C%20mysterious%20atmosphere%2C%20professional%20film%20poster%20style%2C%20rich%20amber%20and%20teal%20color%20palette%2C%20cinematic%20composition&width=640&height=360&seq=media-suspense-drama-02&orientation=landscape',
    duration: '1:48',
  },
  {
    title: '经典回顾 · 豆瓣9分以上必看佳作',
    label: '经典',
    image: 'https://readdy.ai/api/search-image?query=Classic%20film%20scene%20with%20vintage%20cinematic%20aesthetic%2C%20warm%20nostalgic%20lighting%2C%20elegant%20old%20Hollywood%20style%20composition%2C%20rich%20golden%20and%20sepia%20tones%2C%20romantic%20atmosphere%2C%20professional%20movie%20poster%20quality&width=640&height=360&seq=media-classic-film-03&orientation=landscape',
    duration: '3:12',
  },
  {
    title: '即将上线 · 年度期待新片前瞻',
    label: '期待',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20movie%20scene%20with%20stunning%20visual%20effects%2C%20cinematic%20lighting%20with%20cool%20and%20warm%20contrast%2C%20epic%20scale%20composition%2C%20professional%20film%20poster%20aesthetic%2C%20rich%20atmospheric%20colors%2C%20dramatic%20and%20grand&width=640&height=360&seq=media-upcoming-film-04&orientation=landscape',
    duration: '2:08',
  },
];

export const topics = [
  { name: '科幻巨制', count: '2.3万', color: 'accent' },
  { name: '悬疑烧脑', count: '1.8万', color: 'primary' },
  { name: '国产动画', count: '1.5万', color: 'secondary' },
  { name: '漫威宇宙', count: '2.1万', color: 'accent' },
  { name: '韩剧推荐', count: '1.9万', color: 'primary' },
  { name: '纪录片精选', count: '8900', color: 'secondary' },
  { name: '喜剧片单', count: '1.2万', color: 'accent' },
  { name: '恐怖惊悚', count: '9600', color: 'primary' },
  { name: '经典港片', count: '1.4万', color: 'secondary' },
  { name: '日剧精选', count: '7800', color: 'accent' },
];

export const appPromo = {
  title: '随时随地，高清追剧不卡顿',
  subtitle: '88影视网移动端专属观影入口，支持断点续播、离线缓存、智能推荐',
  features: [
    { icon: 'ri-smartphone-line', text: '手机平板全适配' },
    { icon: 'ri-download-cloud-2-line', text: '离线缓存随时看' },
    { icon: 'ri-speed-up-line', text: '智能加速不卡顿' },
    { icon: 'ri-notification-3-line', text: '更新提醒不错过' },
  ],
  image: 'https://readdy.ai/api/search-image?query=Elegant%20modern%20smartphone%20mockup%20displaying%20a%20movie%20streaming%20app%20interface%20with%20cinematic%20film%20posters%2C%20clean%20dark%20UI%20design%20with%20warm%20golden%20accents%2C%20professional%20app%20screenshot%20aesthetic%2C%20floating%20phone%20on%20soft%20neutral%20background%2C%20minimal%20product%20photography&width=600&height=800&seq=app-mockup-01&orientation=portrait',
};

export const carouselItems = [
  {
    title: '暑期档必看片单：这些大片你不能错过',
    category: '专题策划',
    summary: '精心整理2026暑期档最值得期待的10部院线大片和流媒体新片，涵盖动作、科幻、动画等多种类型。',
    image: 'https://readdy.ai/api/search-image?query=Summer%20blockbuster%20movie%20collage%20with%20explosive%20action%20scenes%2C%20bright%20sunny%20cinematic%20lighting%2C%20vibrant%20movie%20poster%20aesthetic%2C%20warm%20golden%20hour%20tones%2C%20epic%20film%20compilation%20style%2C%20professional%20entertainment%20graphic&width=800&height=450&seq=carousel-summer-blockbuster-01&orientation=landscape',
    tag: '热门',
  },
  {
    title: '国产科幻崛起：从《流浪地球》到《三体》',
    category: '深度盘点',
    summary: '回望中国科幻电影十年历程，从技术突破到叙事成熟，国产科幻如何一步步征服全球观众。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20film%20visual%20with%20futuristic%20space%20station%20and%20Earth%2C%20cinematic%20lighting%20with%20deep%20blues%20and%20warm%20golden%20highlights%2C%20epic%20scale%2C%20professional%20movie%20concept%20art%20style%2C%20grand%20and%20atmospheric&width=800&height=450&seq=carousel-scifi-rise-02&orientation=landscape',
    tag: '深度',
  },
  {
    title: '那些年我们追过的神剧：经典永不过时',
    category: '怀旧专题',
    summary: '从《西游记》到《权力的游戏》，一部部跨越时代的经典剧集如何塑造了我们的观剧记忆。',
    image: 'https://readdy.ai/api/search-image?query=Nostalgic%20collection%20of%20classic%20TV%20show%20moments%2C%20warm%20vintage%20cinematic%20lighting%2C%20golden%20sepia%20tones%2C%20emotional%20and%20memorable%20scenes%20collage%2C%20professional%20entertainment%20montage%20aesthetic&width=800&height=450&seq=carousel-classic-shows-03&orientation=landscape',
    tag: '经典',
  },
  {
    title: '全球票房TOP100：影史最卖座电影全盘点',
    category: '数据报告',
    summary: '截至2026年7月最新全球票房排名，哪些电影跻身百亿美元俱乐部？数据背后有哪些产业趋势？',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20box%20office%20visualization%20with%20glowing%20film%20reels%20and%20golden%20statistics%2C%20luxurious%20movie%20theater%20aesthetic%2C%20warm%20spotlight%20and%20red%20curtain%20atmosphere%2C%20professional%20Hollywood%20style%20graphic%20design&width=800&height=450&seq=carousel-box-office-04&orientation=landscape',
    tag: '数据',
  },
];

export const rankingItems = [
  {
    rank: 1,
    title: '流浪地球2',
    meta: '科幻 / 冒险',
    score: '9.4',
    trend: 'up',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20sci-fi%20space%20film%20featuring%20Earth%20and%20spaceships%2C%20dark%20dramatic%20lighting%20with%20warm%20golden%20accents%2C%20professional%20film%20poster%20style&width=120&height=160&seq=rank-wandering-earth-01&orientation=portrait',
  },
  {
    rank: 2,
    title: '狂飙',
    meta: '剧情 / 犯罪',
    score: '9.3',
    trend: 'up',
    image: 'https://readdy.ai/api/search-image?query=Crime%20drama%20movie%20poster%20with%20intense%20urban%20night%20scene%2C%20dark%20moody%20atmosphere%20with%20neon%20accents%2C%20professional%20Chinese%20TV%20series%20poster%20style&width=120&height=160&seq=rank-the-knockout-02&orientation=portrait',
  },
  {
    rank: 3,
    title: '漫长的季节',
    meta: '悬疑 / 剧情',
    score: '9.2',
    trend: 'stable',
    image: 'https://readdy.ai/api/search-image?query=Mystery%20drama%20poster%20with%20nostalgic%201990s%20Chinese%20setting%2C%20warm%20autumn%20tones%2C%20melancholic%20atmosphere%2C%20professional%20TV%20series%20poster%20aesthetic&width=120&height=160&seq=rank-long-season-03&orientation=portrait',
  },
  {
    rank: 4,
    title: '三体',
    meta: '科幻 / 剧情',
    score: '9.1',
    trend: 'up',
    image: 'https://readdy.ai/api/search-image?query=Sci-fi%20mystery%20poster%20with%20cosmic%20and%20astronomical%20elements%2C%20deep%20space%20background%2C%20mysterious%20atmosphere%2C%20professional%20sci-fi%20series%20poster%20style&width=120&height=160&seq=rank-three-body-04&orientation=portrait',
  },
  {
    rank: 5,
    title: '繁花',
    meta: '剧情 / 年代',
    score: '8.9',
    trend: 'down',
    image: 'https://readdy.ai/api/search-image?query=Period%20drama%20poster%20set%20in%201990s%20Shanghai%2C%20elegant%20retro%20aesthetic%2C%20warm%20golden%20lighting%2C%20professional%20Chinese%20TV%20series%20poster%20style&width=120&height=160&seq=rank-blossoms-05&orientation=portrait',
  },
];

export const indexItems = [
  { title: '动作大片', icon: 'ri-fire-line', count: '1,286部', color: 'accent' },
  { title: '喜剧合集', icon: 'ri-emotion-laugh-line', count: '892部', color: 'primary' },
  { title: '科幻巨制', icon: 'ri-rocket-line', count: '654部', color: 'secondary' },
  { title: '爱情经典', icon: 'ri-heart-line', count: '1,103部', color: 'accent' },
  { title: '悬疑推理', icon: 'ri-search-eye-line', count: '768部', color: 'primary' },
  { title: '恐怖惊悚', icon: 'ri-ghost-line', count: '523部', color: 'secondary' },
  { title: '动画天地', icon: 'ri-magic-line', count: '941部', color: 'accent' },
  { title: '纪录纪实', icon: 'ri-film-line', count: '437部', color: 'primary' },
  { title: '国产佳剧', icon: 'ri-china-railway-line', count: '2,156部', color: 'secondary' },
];

export const features = [
  {
    icon: 'ri-4k-line',
    title: '超清画质',
    description: '支持1080P至4K多种分辨率，画质清晰不模糊，自适应带宽智能切换，确保最佳观影效果。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '流畅不卡顿',
    description: '全球CDN智能加速节点覆盖，秒开秒播零等待，高清不卡顿影视体验，告别缓冲烦恼。',
  },
  {
    icon: 'ri-database-2-line',
    title: '海量资源库',
    description: '数万部高清电影电视剧持续更新，涵盖国内外热门大片、经典老片、小众佳作，满足多元观影需求。',
  },
];

export const about = {
  title: '关于88影视网',
  paragraphs: [
    '88影视网是一个专注于高清影视在线观看的综合平台，自上线以来始终致力于为广大影迷提供画质清晰、播放流畅的观影服务。我们汇聚了海量高清电影电视剧资源，涵盖动作、科幻、悬疑、喜剧、爱情、动画等多种题材，从最新院线大片到经典口碑佳作，从热播国产剧到海外精选内容，应有尽有。',
    '平台采用先进的视频编码与CDN加速技术，支持1080P乃至4K超清影视播放，配合智能带宽自适应功能，让每一位用户无论身处何地都能享受高清不卡顿影视体验。同时，我们建立了专业的内容更新机制，每日追踪全球影视动态，第一时间为观众呈现最新上线的高清视频内容。',
    '88影视网坚持以用户为中心，持续优化播放体验与内容推荐算法，致力于打造一个让影迷真正感到贴心的高清视频网站。无论您是资深影迷还是追剧达人，这里都将是您畅享高清在线观看的理想之选。',
  ],
  stats: [
    { value: '50,000+', label: '影视资源' },
    { value: '8,000万+', label: '累计用户' },
    { value: '99.7%', label: '播放成功率' },
  ],
};

export const comments = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Chinese%20man%2C%20warm%20friendly%20expression%2C%20clean%20neutral%20background%2C%20natural%20studio%20lighting%2C%20professional%20profile%20photo&width=80&height=80&seq=avatar-user-01&orientation=squarish',
    name: '星辰大海',
    date: '2026-07-28',
    text: '用了好几年了，片源更新速度真的快，画质也没得说。流浪地球2的4K版就是在这里看的，清晰度完全不输正版平台，关键还不卡，推荐给所有影迷朋友。',
    rating: 5,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Chinese%20woman%2C%20warm%20smile%2C%20clean%20minimal%20background%2C%20soft%20natural%20lighting%2C%20professional%20profile%20photo&width=80&height=80&seq=avatar-user-02&orientation=squarish',
    name: '追剧小达人',
    date: '2026-07-25',
    text: '追《狂飙》那会儿全靠88影视，更新比别家快半天，画质也稳定。现在看《三体》也是在这追的，移动端体验越来越好，地铁上也能流畅看。',
    rating: 5,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20middle-aged%20Chinese%20man%2C%20friendly%20confident%20expression%2C%20clean%20neutral%20background%2C%20natural%20studio%20lighting%2C%20professional%20profile%20photo&width=80&height=80&seq=avatar-user-03&orientation=squarish',
    name: '老电影发烧友',
    date: '2026-07-22',
    text: '最让我惊喜的是经典老片的资源库，很多冷门老港片和欧洲文艺片都能找到高清版。分类索引也很清晰，找片不费劲。希望能一直保持这个品质。',
    rating: 4,
  },
];

export const faqItems = [
  {
    question: '88影视网的视频画质如何？',
    answer: '88影视网提供1080P全高清和4K超清等多种画质选项，采用先进的视频编码技术确保画质清晰不模糊。系统会根据您的网络带宽智能匹配最佳分辨率，让您畅享高清不卡顿影视体验。',
  },
  {
    question: '播放时为什么会卡顿？如何解决？',
    answer: '播放卡顿通常与当前网络环境有关。建议您检查网络连接是否稳定，尝试切换到较低分辨率，或关闭其他占用带宽的应用。88影视网部署了全球CDN加速节点，正常情况下可实现秒开秒播。',
  },
  {
    question: '平台上的影视资源更新频率如何？',
    answer: '我们保持每日更新节奏，热门院线大片在首映后及时上线，热播剧集与卫视同步更新。影视快讯模块实时追踪全球影视动态，确保您不错过任何精彩内容。',
  },
  {
    question: '是否支持手机和平板观看？',
    answer: '完全支持。88影视网针对移动端进行了深度适配，在手机和平板上均可获得流畅的高清在线观看体验。支持断点续播和智能推荐功能，随时随地追剧不中断。',
  },
  {
    question: '需要注册账号才能观看吗？',
    answer: '88影视网目前为开放平台，无需注册即可直接浏览和观看全部高清影视内容。我们致力于为每一位访客提供最便捷的高清视频网站服务体验。',
  },
];

export const contactInfo = {
  title: '联系我们',
  description: '如果您有任何关于高清影视在线观看的建议、资源需求或合作意向，欢迎通过以下方式与我们取得联系。88影视网始终重视每一位影迷的声音。',
  email: 'feedback@88yingshi.com',
  wechat: '88yingshi_official',
  qq: '4001234567',
  tips: '工作时间：周一至周日 9:00 - 22:00，我们会在24小时内回复您的反馈。',
};

export const cardItems = [
  {
    title: '《流浪地球3》前瞻：太阳危机终极之战',
    category: '深度解析',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20scene%20with%20massive%20spaceship%20approaching%20the%20sun%2C%20dramatic%20warm%20golden%20solar%20lighting%2C%20epic%20scale%2C%20professional%20film%20concept%20art%2C%20rich%20atmospheric%20composition&width=640&height=400&seq=card-wandering-3-01&orientation=landscape',
    summary: '郭帆导演如何将中国科幻推向新高度？从技术、叙事到文化表达的全面升级之路。',
    date: '2026-07-30',
  },
  {
    title: '2026下半年最值得期待的10部国产剧',
    category: '追剧指南',
    image: 'https://readdy.ai/api/search-image?query=Collection%20of%20Chinese%20TV%20drama%20scenes%20in%20warm%20cinematic%20lighting%2C%20elegant%20costume%20and%20modern%20drama%20blend%2C%20professional%20entertainment%20collage%20aesthetic%2C%20rich%20golden%20and%20amber%20tones&width=640&height=400&seq=card-cdrama-guide-02&orientation=landscape',
    summary: '古装、悬疑、都市、科幻全覆盖，这份片单帮你提前锁定下半年的追剧计划。',
    date: '2026-07-28',
  },
  {
    title: '诺兰新片《奥德赛》首曝片场照，全明星阵容炸裂',
    category: '海外速递',
    image: 'https://readdy.ai/api/search-image?query=Epic%20mythological%20film%20scene%20with%20ancient%20Greek%20aesthetic%2C%20dramatic%20natural%20lighting%2C%20cinematic%20golden%20hour%20composition%2C%20professional%20film%20production%20still%2C%20grand%20atmospheric%20scale&width=640&height=400&seq=card-nolan-odyssey-03&orientation=landscape',
    summary: '马特·达蒙、汤姆·霍兰德、赞达亚齐聚，诺兰首次挑战史诗神话题材。',
    date: '2026-07-26',
  },
  {
    title: '韩剧年度黑马《重症外伤中心》为何口碑爆棚？',
    category: '口碑推荐',
    image: 'https://readdy.ai/api/search-image?query=Intense%20medical%20drama%20scene%20in%20hospital%20emergency%20room%2C%20dramatic%20lighting%20with%20cool%20and%20warm%20contrast%2C%20emotional%20and%20tense%20atmosphere%2C%20professional%20Korean%20drama%20cinematography%20style&width=640&height=400&seq=card-kdrama-trauma-04&orientation=landscape',
    summary: '没有流量明星，没有狗血爱情，一部纯靠剧本和演技杀出重围的医疗剧。',
    date: '2026-07-24',
  },
  {
    title: '豆瓣9.5！《地球脉动》第三季：每一帧都是壁纸',
    category: '纪录精选',
    image: 'https://readdy.ai/api/search-image?query=Breathtaking%20nature%20documentary%20scene%20with%20diverse%20wildlife%20in%20golden%20sunlight%2C%20stunning%20landscape%20cinematography%2C%20warm%20natural%20tones%2C%20professional%20BBC%20style%20nature%20photography&width=640&height=400&seq=card-planet-earth-05&orientation=landscape',
    summary: '耗时五年拍摄，覆盖43个国家，BBC再次用镜头重新定义了自然纪录片的标杆。',
    date: '2026-07-22',
  },
  {
    title: '动画电影《哪吒之魔童闹海》票房突破80亿',
    category: '票房战报',
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20animation%20film%20scene%20with%20mythological%20warrior%20in%20dramatic%20battle%2C%20vibrant%20warm%20colors%20with%20golden%20and%20red%20tones%2C%20professional%20animated%20film%20aesthetic%2C%20grand%20cinematic%20composition&width=640&height=400&seq=card-nezha-06&orientation=landscape',
    summary: '国漫之光再创历史，光线彩条屋宣布封神宇宙后续多部作品已进入制作阶段。',
    date: '2026-07-20',
  },
  {
    title: '冷门佳片挖掘：这5部小众电影评分9分以上',
    category: '冷门推荐',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20independent%20film%20scene%20with%20warm%20intimate%20lighting%2C%20cinematic%20indie%20movie%20aesthetic%2C%20soft%20golden%20and%20amber%20tones%2C%20thoughtful%20composition%2C%20professional%20arthouse%20film%20photography&width=640&height=400&seq=card-indie-films-07&orientation=landscape',
    summary: '没有大制作，没有名导演，但它们的故事和情感深度足以震撼每一位观众。',
    date: '2026-07-18',
  },
];